import React, { useMemo } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createAppTheme } from '.';
import { DEFAULT_BRAND, getBrand } from './brands';
import { BrandContext } from './brands/useBrand';
import { DashboardCompactContext, useBelowXl } from './surfaces/useDashboardCompact';

function AppTheme({ surface, brand, compact, children }) {
  const theme = useMemo(() => createAppTheme({ brand, surface, compact }), [brand, surface, compact]);

  return (
    <BrandContext.Provider value={getBrand(brand)}>
      {/* Sem escolha salva fica no light (o MUI seguiria o sistema). O usuário troca
          pelo ColorSchemeSelector; o public/index.html aplica a escolha antes do bundle. */}
      <ThemeProvider theme={theme} defaultMode="light">
        <CssBaseline />
        {children}
      </ThemeProvider>
    </BrandContext.Provider>
  );
}

// Só o dashboard assina a media query do modo compacto, uma vez, e repassa o
// valor ao tema e aos componentes (useDashboardCompact) pelo contexto.
function DashboardTheme({ brand, children }) {
  const compact = useBelowXl();

  return (
    <DashboardCompactContext.Provider value={compact}>
      <AppTheme surface="dashboard" brand={brand} compact={compact}>
        {children}
      </AppTheme>
    </DashboardCompactContext.Provider>
  );
}

// A marca virá do domínio (provider); até lá, sempre a padrão.
export default function AppThemeProvider({ surface, brand = DEFAULT_BRAND, children }) {
  if (surface === 'dashboard') {
    return <DashboardTheme brand={brand}>{children}</DashboardTheme>;
  }

  return (
    <AppTheme surface={surface} brand={brand} compact={false}>
      {children}
    </AppTheme>
  );
}
